import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import addressdetails from '../../../assets/img/address-details.jpg';
import { IoLocation } from 'react-icons/io5';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { getCountryDropdown, getStateDropdown, updateBillingAddress, viewAddressDetails } from '../../../Redux/User/action';
import loader from '../../../assets/img/loader.gif';
import { setUserLoginDetails } from '../../../slices/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';

const AddAddressDetails = () => {
    const dispatch = useDispatch()
    const users = useSelector((state) => state.user)

    const navigate = useNavigate();
    const [adsress, setAddress] = useState({})
    const [countries, setCountries] = useState();
    const [states, setStates] = useState();
    const [isloader, setIsloader] = useState(false);
    const [businesstype, setBusinesstype] = useState();
    useEffect(() => {
        viewAddressDetails()(async (response) => {
            if (response && response.status) {
                setAddress(response?.data)

                await getState(response?.data[0]?.country_id)
                await formik.setValues({
                    ...formik.values,
                    address1: response?.data[0]?.address1,
                    address2: response?.data[0]?.address2,
                    city: response?.data[0]?.city,
                    country_id: response?.data[0]?.country_id,
                    state: response?.data[0]?.state_id,
                    zip_code: response?.data[0]?.zip_code,
                    business_type: response?.data[0]?.business_type,
                })
            }
        });

        getCountryDropdown()((response) => {
            if (response && response.status) {
                setCountries(response?.data)
            }
        });
    }, []);
    const validationSchema = Yup.object().shape({

        address1: Yup.string()
            .required('Required'),
        address2: Yup.string()
            .required('Required'),
        city: Yup.string().matches(/^[a-zA-Z0-9 ]+$/, 'Enter a valid City')
            .required('Required'),
        state: Yup.string()
            .required('Required'),
        zip_code: Yup.string()
            .required('Required'),
        business_type: Yup.string()
            .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            address1: "",
            address2: "",
            city: "",
            state: "",
            business_type: "",
            zip_code: "",

        },
        validationSchema,
        onSubmit: (values) => {
            setIsloader(true)

            updateBillingAddress(values)((response) => {
                if (response && response.status) {
                    setIsloader(false)
                    dispatch(setUserLoginDetails({
                        ...users,
                        isAuth: true,


                    }))
                    navigate('/')
                }
                else {

                    formik.setErrors({
                        address1: response?.response?.data?.data?.errors?.address1,
                    });
                    setIsloader(false)
                }
            });
        },
    });
    const getState = async (value) => {
        await getStateDropdown(value)((response) => {
            if (response && response.status) {
                setStates(response?.data)
            }
        });
    }

    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Add Your Address </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Add Your Address</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="address-details">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <img src={addressdetails} alt="" className="img-fluid" />
                        </div>
                        <div className="col-lg-6">
                            <div className="addressdetails-form">
                                <Form onSubmit={formik.handleSubmit}>
                                    <div className='billing-address'>
                                        <h5><IoLocation color='#1bbaed' size={25} className='me-1' /> Provide Billing Address</h5>
                                    </div>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Address Line1 <span style={{ color: "#db3131" }}>*</span></Form.Label>

                                        <Form.Control
                                            type="text"
                                            name='address1'
                                            value={formik.values?.address1}
                                            onChange={formik.handleChange}
                                            placeholder="Address Line1"
                                            maxLength={500}
                                            // minLength={10}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.address1}</Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Address Line2 <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name='address2'
                                            value={formik.values?.address2}
                                            onChange={formik.handleChange}
                                            placeholder="Address Line2"
                                            maxLength={500}
                                            // minLength={10}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.address2}</Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Town or City <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name='city'
                                            value={formik.values?.city}
                                            onChange={formik.handleChange}
                                            isValid={formik.touched.city && !formik.errors.city}
                                            isInvalid={!!formik.errors.city}
                                            placeholder="Town or City"
                                            maxLength={40}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.city}</Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Pin Code <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name='zip_code'
                                            value={formik.values?.zip_code}
                                            onChange={formik.handleChange}
                                            isValid={formik.touched.zip_code && !formik.errors.zip_code}
                                            isInvalid={!!formik.errors.zip_code}
                                            placeholder="Pin Code"
                                            maxLength={6}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.city}</Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Country <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                        <Form.Select aria-label="Default select example" name='country_id' value={formik.values?.country_id} required onChange={(e) => getState(e.target.value)}>
                                            <option value="">Select Country</option>
                                            {countries?.map((country, index) =>
                                                <option key={index} value={country?.id}>{country?.country_name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>State <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                        <Form.Select aria-label="Default select example" name='state' value={formik.values?.state} required onChange={formik.handleChange}>

                                            <option value="">Select State</option>
                                            {states?.map((state, index) =>
                                                <option key={index} value={state?.id}>{state?.state_name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Business Type <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                        <Form.Select aria-label="Default select example" name='business_type' value={formik.values?.business_type} required onChange={formik.handleChange}>
                                            <option value="">Select Type</option>
                                            <option value={"llp"}>LLP</option>
                                            <option value={"ngo"}>NGO</option>
                                            <option value={"individual"}>INDIVIDUAL</option>
                                            <option value={"private_limited"}>PRIVATE LIMITED</option>
                                            <option value={"other"}>OTHER</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <div className="userdetails-form-btn">
                                        {isloader == true ?
                                            <div className='loader'>
                                                <img src={loader} alt="" />
                                            </div>
                                            :
                                            <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3">Submit</Button>
                                        }
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default AddAddressDetails;